import type { ReactNode } from 'react';
import { Button } from './Button';

interface Props {
  open: boolean;
  title: string;
  children: ReactNode;
  tone?: 'success' | 'error';
  onClose: () => void;
  /** Кастомные кнопки внизу; по умолчанию — «Понятно». */
  footer?: ReactNode;
}

export function Modal({ open, title, children, tone = 'success', onClose, footer }: Props) {
  if (!open) return null;

  const icon = tone === 'success' ? '✓' : '!';
  const iconClass =
    tone === 'success'
      ? 'bg-emerald-100 text-emerald-700'
      : 'bg-red-100 text-red-700';

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-xl">
        <div className="flex items-start gap-4 mb-4">
          <div
            className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold ${iconClass}`}
          >
            {icon}
          </div>
          <div className="min-w-0">
            <h3 id="modal-title" className="text-lg font-semibold text-slate-900">
              {title}
            </h3>
            <div className="mt-2 text-slate-600 text-sm leading-relaxed">{children}</div>
          </div>
        </div>
        <div className="flex justify-end gap-2 flex-wrap">
          {footer ?? <Button onClick={onClose}>Понятно</Button>}
        </div>
      </div>
    </div>
  );
}
